export default __webpack_public_path__ + "static/media/OstraGoinge_full.f2ec26be.png";